module.exports = __webpack_public_path__ + "static/BTS_Storyboarding-e0a7380d398447872639790d99c97255.jpg";